// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TMOE","index":"styles_index__1UEAX"};